import "./buttonsbowl.sass";

export default function Buttonsbowl({ superBowlWinner, handleReset }) {

  return (
    <button className="reset-superbowl-button" onClick={handleReset}>
      Reiniciar
    </button>
  );
}